import React from 'react';
import ContentBox from '../components/ContentBox';

function CommunityGuidelines() {
    const lastUpdated = '30 April 2026';

    const sections = [
        {
            title: 'Who This Site Is For',
            content: [
                'Frankly Origins is an 18+ fan site for players of Habbo Origins. By using this site, you confirm that you are at least 18 years old.',
                'We are a community of adults who share an interest in Habbo Origins. The site has a casual, relaxed vibe - we are not here to be preachy, but we do expect everyone to behave like a grown-up.',
            ],
        },
        {
            title: 'Be Decent',
            content: [
                'We have a zero-tolerance policy for the following:',
                [
                    'Harassment, bullying, or targeted abuse of any other user.',
                    'Hate speech or content that discriminates based on race, ethnicity, gender, sexuality, religion, disability, or any other protected characteristic.',
                    'Threatening, intimidating, or deliberately trying to make someone feel unwelcome.',
                    'Impersonating other users, staff, or real individuals.',
                    'Sharing another person\'s private information without their consent (doxxing).',
                ],
                'Disagreements happen - that is fine. Directing hostility at another person is not.',
            ],
        },
        {
            title: 'Content Standards',
            content: [
                'Frankly Origins is a safe-for-work environment. This applies to everything you post, upload, or display on your profile.',
                'The following content is not permitted anywhere on the site:',
                [
                    'Explicit sexual content (i.e., pornographic material).',
                    'Content that is illegal under UK or EU law, or in your country of residence.',
                    'Image content involving minors in any context, or inappropriate written content involving minors.',
                    'Graphic violence or gore.',
                    'Content that glorifies or promotes self-harm or suicide.',
                    'Spam, scam links, or phishing attempts.',
                ],
                'Keep it safe for work. You can still have fun and express your personality without crossing these lines.',
            ],
        },
        {
            title: 'Image Uploads (FranklyCloud)',
            content: [
                'FranklyCloud lets you upload and store images on the site. All uploaded images are scanned by an AI moderation service before being accepted. This is not a replacement for your own judgement.',
                'When uploading images, please ensure that:',
                [
                    'The image does not contain explicit nudity, sexual content, or anything that would not be appropriate in a public-facing setting. Tom Holland shirtless is acceptable.',
                    'You own the image or have the right to upload it. Do not upload content that belongs to someone else without permission.',
                    'The image does not depict real-world violence, illegal activity, or hate-based content.',
                    'The image is not designed to harass or target another individual.',
                ],
                'Images that violate these guidelines may be removed by an administrator without notice. Repeated or severe violations may result in your ability to upload being restricted or your account being suspended.',
            ],
        },
        {
            title: 'Profiles and Customisation',
            content: [
                'Your profile is visible to other users of the site. Please ensure that your profile content - including your status, about section, and any images you display - complies with these guidelines.',
                'Profile content that contains hate speech, explicit material, targeted abuse, or any of the prohibited content listed above will be removed.',
            ],
        },
        {
            title: 'Comments and Posts',
            content: [
                'When commenting on articles or interacting with posts, keep the conversation on topic and constructive.',
                [
                    'Do not post spam or repeat the same content across multiple posts.',
                    'Do not use comments as a platform to attack or demean other users.',
                    'Do not post links to external sites that are harmful, deceptive, or illegal.',
                ],
                'We reserve the right to remove any comment or post that violates these guidelines, even if it is not explicitly covered above.',
            ],
        },
        {
            title: 'Enforcement',
            content: [
                'If you break these guidelines, we may take action depending on the severity and frequency of the violation. This can include:',
                [
                    'Removal of the offending content.',
                    'A warning issued to your account.',
                    'Temporary or permanent restriction of specific features (such as upload access or commenting).',
                    'Suspension or permanent ban from the site.',
                ],
                'Serious violations - particularly anything involving illegal content - will be actioned immediately and without warning. Relevant authorities will be contacted if required.',
                'If you believe a user is violating these guidelines, please report it to us in our Discord or directly to any Frankly Staff member.',
            ],
        },
        {
            title: 'Changes to these Guidelines',
            content: [
                'We may update the Community Guidelines from time to time. When we do, the "Last Updated" date at the top of this page will reflect the change. Continued use of Frankly Origins after any changes constitutes acceptance of the updated policy.',
            ],
        },
        {
            title: 'Contact',
            content: [
                'If you have any questions about these guidelines or want to report a concern, you can reach us in our Discord or directly with any Frankly Staff member.',
            ],
        },
    ];

    const renderContent = (content) =>
        content.map((item, i) => {
            if (Array.isArray(item)) {
                return (
                    <ul key={i} className="list-disc list-inside space-y-1 ml-2 mt-1 mb-2">
                        {item.map((li, j) => (
                            <li key={j} className="text-gray-700 text-sm leading-relaxed">
                                {li}
                            </li>
                        ))}
                    </ul>
                );
            }
            return (
                <p key={i} className="text-gray-700 text-sm leading-relaxed mb-2">
                    {item}
                </p>
            );
        });

    return (
        <div className="w-full min-h-screen p-4 lg:p-6">
            <ContentBox theme="default" tint="lightskyblue" header="Community Guidelines">
                <div className="mb-4 pb-3 border-b border-gray-200">
                    <p className="text-xs text-gray-500 font-['Jersey_10'] uppercase tracking-wide">
                        Last Updated: {lastUpdated}
                    </p>
                    <p className="text-sm text-gray-700 mt-2 leading-relaxed">
                        Frankly Origins is a community for adult Habbo Origins players. These guidelines exist to keep the site a decent place for everyone. They are not exhaustive - we expect you to use common sense, and we reserve the right to act on anything that we consider harmful to the community, whether or not it is explicitly listed here.
                    </p>
                </div>

                <div className="space-y-5">
                    {sections.map((section, i) => (
                        <div key={i}>
                            <h3 className="font-['Jersey_10'] uppercase text-[16px] tracking-[1px] text-maroon mb-2">
                                {i + 1}. {section.title}
                            </h3>
                            <div>{renderContent(section.content)}</div>
                        </div>
                    ))}
                </div>
            </ContentBox>
        </div>
    );
}

export default CommunityGuidelines;
